module.exports = "<svg viewBox=\"0 0 24 24\"><polygon fill=\"currentcolor\" points=\"10 6 8.59 7.41 13.17 12 8.59 16.59 10 18 16 12\"></polygon></svg>"